var base = require('settings/settings');

export default {
  mixins: [base],
  template: '#spark-settings',
  data() {
    return {
      Events: window.Events,
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/settings.js